<template>
  <component
      :is="(url) ? isExternal ? 'a' : NuxtLink : 'button'"
      class="button"
      :href="url"
      :type="type"
      :target="isExternal ? '_blank' : '_self'"
      :rel="isExternal ? 'noopener noreferrer' : undefined"
      :disabled="disabled"
  >
    <AppIconLoader v-if="leadIcon" :name="leadIcon" aria-hidden="true" class="button__icon"/>
    {{ title }}
    <AppIconLoader v-if="endIcon" name="arrowRight" variant="small" aria-hidden="true" class="button__icon"/>
  </component>
</template>

<script setup lang="ts">
import NuxtLink from "#app/components/nuxt-link";
import {ref, onMounted} from 'vue'

const props = defineProps({
  title: {type: String, default: undefined, required: true},
  type: {type: String, default: undefined, required: false},
  leadIcon: {type: String, default: undefined, required: false},
  endIcon: {type: Boolean, default: false, required: false},
  url: {type: String, required: false, default: undefined},
  disabled: {type: Boolean, default: false, required: false},
})

const isExternal = ref(false)

onMounted(() => {
  if (props.url && props.url.startsWith('http') && !props.url.includes(window.location.hostname)) {
    isExternal.value = true
  }
})

</script>

<style scoped lang="postcss">
.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  border-radius: 55px;
  border-width: 3px;
  border-color: var(--color-blue-aqua);
  background-color: var(--color-blue-aqua);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.25;
  color: var(--color-blue-prussian);
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }

  &:focus-visible {
    background-color: var(--color-blue-prussian);
    color: var(--color-blue-aqua);
  }

  &__icon {
    flex-shrink: 0;
  }

  &:disabled {
    opacity: 0.5 !important;
    cursor: not-allowed;
  }
}
</style>
